import { formatPhoneNumber } from "@/utils/phoneNumberFormatter";
import React from "react";
import { Button, Form } from "react-bootstrap";
import VerificationTick from "../../../../../../public/assets/images/verificationTick.svg";
import VerificationPending from "../../../../../../public/assets/images/verificationPending.svg";

const PhoneInputField = ({
  item,
  formRef,
  value,
  onChange,
  onBlur,
  type,
  isVerified,
  setShowVerifyModal,
}) => {
  return (
    <div className="position-relative">
      <Form.Control
        ref={formRef}
        type={item.type}
        aria-label={item.formValueLabel}
        className="form-control pp-input-field"
        placeholder={item.placeholder}
        value={formatPhoneNumber(value)}
        onChange={onChange}
        onBlur={onBlur}
        name={item.formValueLabel}
        required={item.required}
      />

      <div
        className="position-absolute"
        style={{ right: "12px", top: "50%", transform: "translateY(-50%)" }}
      >
        {value && (
          <>
            {isVerified ? (
              // <i
              //   className="fa fa-check-circle-o"
              //   style={{ color: "green", fontSize: "24px" }}
              // />
              <img
                src={VerificationTick}
                alt="verified"
                className="phone-verification-icon"
                style={{ height: 24, width: 24 }}
              />
            ) : (
              <>
                <div
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: "8px",
                  }}
                >
                  {/* <i
                    className="fa fa-exclamation-triangle"
                    style={{
                      color: "red",
                      fontSize: "24px",
                    }}
                  /> */}
                  <img
                    src={VerificationPending}
                    alt="verification pending"
                    className="phone-verification-icon"
                    style={{ height: 24, width: 24 }}
                  />
                </div>
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() =>
                    setShowVerifyModal({ show: true, type, phoneNumber: value })
                  }
                >
                  Verify
                </Button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PhoneInputField;
